import type {
  UserMeResponse,
  UserUpdatePreferenceRequest,
  UserUpdatePreferenceResponse,
} from '@quromedical/models';
import { trpcClient } from 'trpc';

export class UserPreferenceApi {
  public registerPushToken = async (pushTokenId: string): Promise<void> => {
    await trpcClient.user.addPushToken.mutate({ pushTokenId });
  };

  public unregisterPushToken = async (pushTokenId: string): Promise<void> => {
    await trpcClient.user.removePushToken.mutate({ pushTokenId });
  };

  public getMe = async (): Promise<UserMeResponse> => {
    return await trpcClient.practitioner.getProfile.query();
  };

  public updatePreference = async (
    body: UserUpdatePreferenceRequest,
  ): Promise<UserUpdatePreferenceResponse> => {
    const result =
      await trpcClient.practitioner.updateUserPreferences.mutate(body);

    return { theme: result.theme };
  };
}
